import React from 'react';
import { FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import { InputProps } from 'reactstrap/types/lib/Input';
import { useController } from 'react-hook-form';

type Props = InputProps & {
  name: string;
  label?: string;
};

const NumberField = ({ name, label, valueDefault, ...props }: Props) => {
  const {
    field,
    fieldState: { invalid, error }
  } = useController({ name, defaultValue: valueDefault });

  return (
    <FormGroup>
      {label && <Label>{label}</Label>}
      <Input
        type={props.type || 'number'}
        {...props}
        {...field}
        invalid={invalid}
      />
      {error && <FormFeedback>{error.message}</FormFeedback>}
    </FormGroup>
  );
};

export default NumberField;
